import Component from '../colorz/Component';

export default class FaqItem extends Component {
	onInit(el) {
		this.el = el;
		this.faqContainer = this.el.querySelector('[data-faq-container]');
		this.faqQuestion = this.el.querySelectorAll('[data-faq-question]');
		this.faqAnchor = this.el.querySelectorAll('[data-faq-anchor-behavior]');
	}

	onReady() {
		const iconLink = this.el.querySelectorAll('[data-link-container]');
		const arrayIconLink = Array.from(iconLink);

		arrayIconLink.forEach((element) => {
			const linkID = element.id;
			const linkURL = element.baseURI;
			const newID = `${linkURL}#${linkID}`;
			const copyMessage = element.querySelector('[data-link-message]');

			element.id = linkID;

			element.addEventListener('click', (event) => {
				event.stopPropagation(); // Empêcher la propagation de l'événement au parent (qui ouvre la question)
				this.copyIdToClipboard(element, copyMessage);
			});
		});

		// Pour chaque question ... je lance les fonctions
		this.faqQuestion.forEach((faqElement) => {
			this.setupQuestionToggle(faqElement);
		});

		// Pour ouvrir automatiquement la question si l'ID est dans l'URL...
		const currentUrl = new URL(window.location.href);
		const hashId = currentUrl.hash.substring(1); // Récupère l'ID après le #

		if (hashId) {
			const targetElement = this.el.querySelector(`#${hashId}`);
			if (targetElement) {
				const faqElement = targetElement.closest('[data-faq-question]');
				if (faqElement) {
					this.openQuestion(faqElement);
				}
			}
		}
	}

	setupQuestionToggle(faqElement) {
		const faqElBtn = faqElement.querySelector('[data-expandable-btn]');

		if (faqElBtn) {
			faqElBtn.addEventListener('click', (event) => {
				// Vérifier si le clic vient de l'icone epingle
				if (!event.target.closest('[data-link-container]')) {
					this.toggleQuestion(faqElement);
				}
			});
		}
	}

	toggleQuestion(faqElement) {
		const faqElWrapper = faqElement.querySelector('[data-expandable-wrapper]');
		const faqElBtn = faqElement.querySelector('[data-expandable-btn]');

		if (faqElBtn && faqElWrapper) {
			const currentIsOpen = faqElBtn.getAttribute('aria-expanded') === 'true';

			// Fermer toutes les questions sauf celle sur laquelle l'utilisateur clique
			this.faqContainer
				.querySelectorAll('[data-expandable-btn]')
				.forEach((btn) => {
					if (btn !== faqElBtn) {
						const parentWrapper = btn.parentNode.querySelector(
							'[data-expandable-wrapper]',
						);
						if (parentWrapper) {
							btn.setAttribute('aria-expanded', 'false');
							parentWrapper.style.display = 'none';
							parentWrapper.setAttribute('aria-hidden', 'true');
						}
					}
				});

			// Mettre à jour l'état isOpen de la question sur laquelle l'utilisateur clique
			faqElBtn.setAttribute('aria-expanded', currentIsOpen ? 'false' : 'true');
			faqElWrapper.style.display = currentIsOpen ? 'none' : 'block';
			faqElWrapper.setAttribute(
				'aria-hidden',
				currentIsOpen ? 'true' : 'false',
			);
		}
	}

	openQuestion(faqElement) {
		const faqElWrapper = faqElement.querySelector('[data-expandable-wrapper]');
		const faqElBtn = faqElement.querySelector('[data-expandable-btn]');

		if (faqElBtn && faqElWrapper) {
			faqElBtn.setAttribute('aria-expanded', 'true');
			faqElWrapper.style.display = 'block';
			faqElWrapper.setAttribute('aria-hidden', 'false');
		}
	}

	copyIdToClipboard(element, copyMessage) {
		const currentUrl = window.location.href.split('#')[0]; // Récupère l'URL sans le hash actuel

		const idValue = element.id;

		// Crée la nouvelle URL avec le nouvel ID
		const newUrl = `${currentUrl}#${idValue.replace(/.*#/, '')}`;

		// Copie la nouvelle URL dans le presse-papiers
		navigator.clipboard
			.writeText(newUrl)
			.then(() => {
				copyMessage.style.display = 'block';
				setTimeout(() => {
					copyMessage.style.display = 'none';
				}, 3000);
			})
			.catch((err) => {
				console.error(
					"Erreur lors de la copie de l'URL dans le presse-papiers :",
					err,
				);
			});
	}
}
